import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import PerfectScrollbar from "react-perfect-scrollbar";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ReadMoreAndLess from "react-read-more-less";
import Grid from "@mui/material/Grid";
import {
  Box,
  Card,
  CardHeader,
  CardContent,
  Paper,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Chip,
  Checkbox,
  IconButton,
} from "@mui/material";
import InfoTwoToneIcon from "@mui/icons-material/InfoTwoTone";
import PermDeviceInformationTwoToneIcon from "@mui/icons-material/PermDeviceInformationTwoTone";

import Cisinformation from "../Cisinformation/Cisinformation";
import ActualValue from "../Cisinformation/MultiActualValue";

import IndividualForm from "./Executions/IndividualForm";
import OverallFrom from "./Executions/OverallSelectedFrom";

import { FormatColorResetOutlined } from "@mui/icons-material";

function EnhancedTableHead() {
  return (
    <>
      <TableHead>
        <TableRow className="align-items-center table-flush css-serial">
          {window.localStorage.getItem("rollback_run_access") ===
          "You do not have permission to perform this action." ? (
            ""
          ) : (
            <React.Fragment>
              <TableCell width="5%" padding="checkbox"></TableCell>
            </React.Fragment>
          )}
          <TableCell width="5%" align="center">
            <h6>Cis_no</h6>
          </TableCell>
          <TableCell align="center">
            <h6>CIS_Topic</h6>
          </TableCell>
          <TableCell width="10%" align="center">
            <h6>Level</h6>
          </TableCell>
          {window.localStorage.getItem("rollback_run_access") ===
          "You do not have permission to perform this action." ? (
            ""
          ) : (
            <TableCell width="5%" align="center">
              <h6>Status</h6>
            </TableCell>
          )}
          <TableCell width="5%" align="center">
            <h6>Result</h6>
          </TableCell>
          <TableCell width="5%" align="center">
            <h6>Info</h6>
          </TableCell>
        </TableRow>
      </TableHead>
    </>
  );
}

const EnhancedTableToolbar = (props) => {
  const { failedcount, customcolor, content, overallcount } = props;
  return (
    <React.Fragment>
      <a>
        <span style={{ color: customcolor }}>
          {content} Audits : {failedcount} / Overall Audits : {overallcount}
        </span>
      </a>
    </React.Fragment>
  );
};

export default function FailedTable(props) {
  const {
    CisResults,
    overallAudit,
    failedAudit,
    hostprimarykey,
    hostname,
    ipdns,
    platform,
    exedate,
    passedaudit,
    userdatatags,
    component,
    skippedAudit,
  } = props;

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const [dropdown, setdropdown] = React.useState([]);
  const [itemselected, setItemselected] = React.useState([]);
  const [itemgroupselected, setItemgroupselected] = React.useState([]);
  const [selectedall, setSelectedall] = React.useState(false);
  const [selectedgroup, setSelectedgroup] = React.useState({});

  const checkmoreinfo = (cis_no) => (e) => {
    e.preventDefault();
    var value;
    if (dropdown[cis_no]) {
      value = false;
    } else {
      value = true;
    }
    setdropdown((prevState) => ({ ...prevState, [cis_no]: value }));
  };

  const [newresult, setNewresult] = React.useState([]);
  const [selected, setSelected] = React.useState([]);
  React.useEffect(() => {
    setNewresult({ CisResults });
    if (CisResults) {
      CisResults.map((val) => {
        val.result.map((row) => {
          if (
            row.status === "PASSED" ||
            row.status === "ROLLBACKFAILED" ||
            row.status === "ROLLEDBACK"
          ) {
            setdropdown((prevState) => ({ ...prevState, [row.cis_no]: false }));
          }
        });
      });
    }
  }, [CisResults]);

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const totalselected = CisResults.map((row) => {
        const seperateResult = row.result.map((value) => {
          if (value.status === "PASSED" || value.status === "ROLLBACKFAILED") {
            const cis_number = value.cis_no;
            return cis_number;
          }
          return null;
        });
        return seperateResult;
      });

      const data = JSON.stringify(totalselected);
      const jsonstrinifydata = data
        .replace(/\[/g, "")
        .replace(/\]/g, "")
        .replace(/[,]+/g, ","); //replace(/,,/g, ',')
      const changeValue = "[" + jsonstrinifydata + "]";
      const jsonparsefield = JSON.parse(changeValue);
      const filtered = jsonparsefield.filter(function (el) {
        return el != null;
      });

      setSelected(filtered);
      setItemselected(filtered);
      setSelectedall(true);
      return null;
    }
    setSelected([]);
    setItemgroupselected([]);
    setSelectedall(false);
    return null;
  };

  const handleSelectGroupClick = (event, tags) => {
    const id = event.target.id;
    if (event.target.checked) {
      const totalselected = tags.map((value) => {
        return value;
      });

      const data = JSON.stringify(totalselected);
      const jsonstrinifydata = data
        .replace(/\[/g, "")
        .replace(/\]/g, "")
        .replace(/[,]+/g, ","); //replace(/,,/g, ',')
      const changeValue = "[" + jsonstrinifydata + "]";
      const jsonparsefield = JSON.parse(changeValue);
      const filtered = jsonparsefield.filter(function (el) {
        return el != null;
      });
      let newSelected = [];
      newSelected = newSelected.concat(selected, filtered);

      setSelected(newSelected);
      setItemgroupselected(filtered);
      setSelectedgroup((prevState) => ({
        ...prevState,
        [id]: true,
      }));
      return null;
    }

    tags.map((row) => {
      var index = selected.indexOf(row);
      console.log(index);
      if (index !== -1) {
        selected.splice(index, 1);
        setSelected(selected);
      }
    });
    setItemgroupselected([]);
    setSelectedgroup((prevState) => ({
      ...prevState,
      [id]: false,
    }));
    setSelectedall(false);
    return null;
  };

  const handleClick = (event, cis_no) => {
    const selectedIndex = selected.indexOf(cis_no);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, cis_no);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    const totalselected = CisResults.map((row) => {
      const seperateResult = row.result.map((value) => {
        if (value.status === "FAILED") {
          const cis_number = value.cis_no;
          return cis_number;
        }
        return null;
      });
      return seperateResult;
    });

    const data = JSON.stringify(totalselected);
    const jsonstrinifydata = data
      .replace(/\[/g, "")
      .replace(/\]/g, "")
      .replace(/[,]+/g, ",");
    const changeValue = "[" + jsonstrinifydata + "]";
    const jsonparsefield = JSON.parse(changeValue);
    const filtered = jsonparsefield.filter(function (el) {
      return el != null;
    });
    setSelected(newSelected);
    setItemselected(filtered);
  };

  const [expandedheader, setExpandedheader] = React.useState({});

  const handleChangedropdown = (panel) => (event, isExpanded) => {
    setExpandedheader(isExpanded ? panel : false);
  };
  const isSelected = (cis_no) => selected.indexOf(cis_no) !== -1;
  const isGroupSelected = (cis_no) => itemgroupselected.indexOf(cis_no) !== -1;

  return (
    <>
      <ActualValue component="remedy" open={open} setOpen={setOpen} />
      <Card>
        <CardHeader
          action={
            <React.Fragment>
              <OverallFrom
                selected={selected}
                itemgroupselected={itemgroupselected}
                component={component}
                cisresult={CisResults}
                overallAudit={overallAudit}
                failedAudit={failedAudit}
                hostname={hostname}
                ipdns={ipdns}
                platform={platform}
                exedate={exedate}
                passedaudit={passedaudit}
                skippedAudit={skippedAudit}
              />
            </React.Fragment>
          }
          title="Passed"
        />
        <div className="mr-2 px-4 py-2">
          <Chip
            icon={
              <React.Fragment>
                <Checkbox
                  indeterminate={
                    selected.length > 0 && selected.length < itemselected.length
                  }
                  checked={
                    itemselected.length > 0 &&
                    selected.length === itemselected.length
                  }
                  onChange={handleSelectAllClick}
                  inputProps={{ "aria-label": "select all desserts" }}
                  title="select all"
                />
              </React.Fragment>
            }
            label={
              <Typography fontWeight="fontWeightBold" variant="h7">
                <strong>Select all</strong>
              </Typography>
            }
            variant="outlined"
          />
        </div>

        {newresult.CisResults ? (
          <React.Fragment>
            {CisResults.map((val, index) => {
              const isItemSelected1 = isSelected(val.header_id);
              const labelId = `select all desserts-${index}`;
              if (val.passedCount > 0 || val.rollbackCount > 0) {
                return (
                  <div>
                    <Accordion
                      defaultExpanded={expandedheader ? true : false}
                      onChange={handleChangedropdown(val.header_id)}
                      style={{ cursor: "pointer" }}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1bh-content"
                        id="panel1bh-header"
                      >
                        <Typography sx={{ width: "33%", flexShrink: 0 }}>
                          <strong>{val.header_id}</strong> - {val.header_name}
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Card>
                          <Paper sx={{ width: "100%" }}>
                            <TableContainer
                              sx={{ minWidth: 1100 }}
                              component={Paper}
                              style={{ borderColor: "#333" }}
                            >
                              <Table
                                aria-labelledby="tableTitle"
                                aria-label="enhanced table"
                              >
                                <TableHead className="bg-lightBlue-200">
                                  <TableRow className="align-items-center table-flush css-serial">
                                    <TableCell
                                      width="5%"
                                      padding="checkbox"
                                    ></TableCell>
                                    <TableCell>Cis_no</TableCell>
                                    <TableCell>CIS_Topic</TableCell>
                                    <TableCell>Level</TableCell>
                                    <TableCell>Status</TableCell>
                                    <TableCell>Result</TableCell>
                                    <TableCell>Info</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {val.result.map((row, sindex) => {
                                    const isItemSelected = isSelected(
                                      row.cis_no
                                    );
                                    const isItemGroupSelected = isGroupSelected(
                                      row.cis_no
                                    );
                                    const labelId = `enhanced-table-checkbox-${sindex}`;
                                    if (
                                      row.status === "PASSED" ||
                                      row.status === "ROLLEDBACK" ||
                                      row.status === "ROLLBACKFAILED"
                                    ) {
                                      return (
                                        <React.Fragment>
                                          <TableRow>
                                            <TableCell>
                                              <Checkbox
                                                hover
                                                onClick={(event) =>
                                                  handleClick(event, row.cis_no)
                                                }
                                                role="checkbox"
                                                aria-checked={isItemSelected}
                                                tabIndex={-1}
                                                selected={isItemSelected}
                                                checked={isItemSelected}
                                                inputProps={{
                                                  "aria-labelledby": labelId,
                                                }}
                                              />
                                            </TableCell>
                                            <TableCell
                                              align="center"
                                              component="th"
                                              id={labelId}
                                              scope="row"
                                              padding="none"
                                              width="5%"
                                            >
                                              {row.cis_no}
                                            </TableCell>
                                            <TableCell
                                              style={{
                                                textAlign: "left",
                                                whiteSpace: "normal",
                                                wordWrap: "break-word",
                                              }}
                                            >
                                              <ReadMoreAndLess
                                                className="read-more-content"
                                                charLimit={100}
                                                readMoreText="Read more"
                                                readLessText="Read less"
                                              >
                                                {row.cis_topic_name}
                                              </ReadMoreAndLess>
                                            </TableCell>
                                            <TableCell
                                              width="10%"
                                              style={{ textAlign: "left" }}
                                            >
                                              {row.level}
                                            </TableCell>
                                            <TableCell
                                              width="10%"
                                              style={{
                                                textAlignLast: "left",
                                              }}
                                            >
                                              <IndividualForm
                                                CIS_NUMBER={row.cis_no}
                                                status={row.status}
                                                selected={selected}
                                                itemgroupselected={
                                                  itemgroupselected
                                                }
                                              />
                                            </TableCell>
                                            <TableCell
                                              width="5%"
                                              style={{
                                                textAlignLast: "center",
                                              }}
                                            >
                                              <IconButton
                                                color="primary"
                                                size="sm"
                                                title="Info"
                                                style={{
                                                  padding: "0px",
                                                  color: "lightgreen",
                                                }}
                                                onClick={() => {
                                                  window.sessionStorage.setItem(
                                                    "passed_before_fact",
                                                    row.before_actual_value
                                                  );
                                                  window.sessionStorage.setItem(
                                                    "passed_after_fact",
                                                    row.after_actual_value
                                                  );
                                                  handleClickOpen();
                                                }}
                                              >
                                                <PermDeviceInformationTwoToneIcon
                                                  fontSize="small"
                                                  color="primary"
                                                />
                                              </IconButton>
                                            </TableCell>
                                            <TableCell
                                              width="5%"
                                              align="center"
                                            >
                                              <IconButton
                                                color="primary"
                                                size="sm"
                                                title="Info"
                                                style={{
                                                  padding: "0px",
                                                  color: "lightgreen",
                                                }}
                                                onClick={checkmoreinfo(
                                                  row.cis_no
                                                )}
                                              >
                                                <InfoTwoToneIcon
                                                  fontSize="small"
                                                  color="lightgreen"
                                                />
                                              </IconButton>
                                            </TableCell>
                                          </TableRow>
                                          {dropdown[row.cis_no] ? (
                                            <TableRow
                                              id={"multiCollapse" + row.cis_no}
                                            >
                                              <Cisinformation
                                                OS={window.sessionStorage.getItem(
                                                  "OS"
                                                )}
                                                FactName={row.fact_name}
                                              />
                                            </TableRow>
                                          ) : (
                                            ""
                                          )}
                                        </React.Fragment>
                                      );
                                    }
                                  })}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Paper>
                        </Card>
                      </AccordionDetails>
                    </Accordion>
                  </div>
                );
              }
            })}
            <CardContent style={{ textAlign: "center" }}>
              <span>
                {" "}
                *If the status is Rollback, you can rollback the remediation by
                clicking on the Rollback button.
              </span>
              <br />
              <span>
                {" "}
                **If the status is Rollback Failed, the rollback was not
                completed successfully. You can retry the rollback by clicking
                on the Rollback Failed button.
              </span>
            </CardContent>
          </React.Fragment>
        ) : (
          <CardContent style={{ textAlign: "center" }}>
            <span>Loading ...</span>
          </CardContent>
        )}
        <br />
        <br />
      </Card>
    </>
  );
}